<template>
    <!-- IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): схема страницы для карточки вида «Previews» панели страниц — прямоугольники виджетов,
         которые откроются со страницей, по её раскладке (utils/pageSchema.js: закреплённые — поток полосами, свободные — поверх, с тенью); значок —
         тип виджета (вкладка: таблица / график / карта / Гант …), название — когда прямоугольник достаточно велик. Без данных и без картинок. -->
    <div class="page-schema" :class="{ 'is-empty': !rects.length }" :style="{ width: width + 'px', height: height + 'px' }" v-uiHelp="help_b">
        <div v-for="r in rects" :key="r.id + ':' + r.order" class="page-schema-w" :class="{ 'is-free': r.free, 'is-multiply': r.multiply, 'has-pic': !!picOf(r) }"
            :style="{ left: r.x + '%', top: r.y + '%', width: r.w + '%', height: r.h + '%' }">
            <!-- IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): у виджета есть картинка — она в прямоугольнике (значок и подпись — только без картинки) -->
            <WidgetPreviewImg v-if="picOf(r)" :pic="picOf(r)" :lay="r.lay" :title="r.title" />
            <template v-else>
            <i v-if="r.showIcon" :class="r.icon" class="page-schema-ico"></i>
            <span v-if="r.showTitle" class="page-schema-t">{{ r.title }}</span>
            </template>
        </div>
        <span v-if="!rects.length" class="page-schema-empty">{{ t('No widgets open with this page') }}</span>
    </div>
</template>

<script>
import { t } from '@/i18n'
import WidgetPreviewImg from './WidgetPreviewImg.vue'   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)

export default {
    name: 'PageSchema',
    components: { WidgetPreviewImg },
    props: {
        schema: { type: Object, default: null },   // pageSchema_build: { rects: [{ id, title, icon, free, multiply, x, y, w, h }], … }
        width: { type: Number, default: 160 },
        height: { type: Number, default: 80 },
        pics: { type: Object, default: null },   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): id виджета → картинка (utils/widgetPreviews.widgetPreviews_picOfRow)
    },
    computed: {
        // подписи — по размеру прямоугольника в px: значок от 14 × 12, название от 56 × 24 (иначе каша из обрезков)
        rects() {
            const W = this.width, H = this.height
            return ((this.schema && this.schema.rects) || []).map(r => {
                const pw = r.w / 100 * W, ph = r.h / 100 * H
                return { ...r, showIcon: pw >= 14 && ph >= 12, showTitle: pw >= 56 && ph >= 24 }
            })
        },
        help_b() {
            const s = this.schema || {}
            return { key: 'menuPanel.preview', vars: () => ({ n: s.count || 0, free: s.free || 0, docked: s.docked || 0 }) }
        },
    },
    methods: {
        t,
        picOf(r) { return (this.pics && r && this.pics[r.id]) || null },   // IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов)
    },
}
</script>

<style>
/* IE 2026 09 26 / ODOO-… (заказ Игоря: виды панели страниц): схема страницы — рабочая область (фон секции), закреплённые виджеты — плашки с рамкой,
   свободные — поверх, с тенью; значки и подписи мелкие, цветом вторичного текста. Не scoped: карточка живёт в телепортированной панели */
.page-schema { position: relative; box-sizing: border-box; overflow: hidden; background: var(--surface-section, #f1f3f5); }
.page-schema-w { position: absolute; box-sizing: border-box; display: flex; align-items: center; justify-content: center; gap: 3px; min-width: 0; padding: 0 2px; overflow: hidden;
    background: var(--surface-card, #fff); border: 1px solid var(--surface-border, #d5d9de); border-radius: 2px; color: var(--text-color-secondary, #6c757d); }
.page-schema-w.is-free { border-color: var(--menu-panel-head, #3d8b3d); box-shadow: 0 1px 3px rgba(0, 0, 0, .28); z-index: 1; }
.page-schema-w.is-multiply { border-style: dashed; }
.page-schema-w.has-pic { padding: 0; }   /* IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): картинка во весь прямоугольник */
.page-schema-ico { flex: 0 0 auto; font-size: 10px; line-height: 1; }
.page-schema-t { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 9px; line-height: 11px; }
.page-schema-empty { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; padding: 0 6px; text-align: center; font-size: 10px; line-height: 12px;
    color: var(--text-color-secondary, #6c757d); opacity: .8; }
</style>
